/*
 * Colours come only from theme/tokens.json (a copy of the desktop app's
 * mt-vox desktop/theme/tokens.json): each token becomes a CSS variable
 * --<name> on :root. Light or dark follows the system unless the user picks.
 */
import { signal } from "@preact/signals";
import tokens from "./theme/tokens.json";

export type ThemeMode = "system" | "light" | "dark";
export const themeMode = signal<ThemeMode>("system");
export const isDark = signal(false);

const media = typeof matchMedia !== "undefined" ? matchMedia("(prefers-color-scheme: dark)") : undefined;

export function applyTheme(mode: ThemeMode = themeMode.value): void {
  themeMode.value = mode;
  const dark = mode === "dark" || (mode === "system" && !!media?.matches);
  isDark.value = dark;
  const set = (tokens as unknown as Record<string, Record<string, string>>)[dark ? "dark" : "light"];
  const root = document.documentElement;
  for (const [k, v] of Object.entries(set)) {
    if (!k.startsWith("_")) root.style.setProperty(`--${k}`, v);
  }
  root.dataset.theme = dark ? "dark" : "light";
  root.style.colorScheme = dark ? "dark" : "light";
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", set.rail);
}

media?.addEventListener("change", () => {
  if (themeMode.value === "system") applyTheme("system");
});

export function logoUrl(): string {
  const set = (tokens as unknown as Record<string, Record<string, string>>)[isDark.value ? "dark" : "light"];
  return `/${set._logo}`;
}
